exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2KwuXAvKbGhLpj4P4f_dW_ {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n._2KwuXAvKbGhLpj4P4f_dW_ canvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n", ""]);

// exports
exports.locals = {
	"Container": "_2KwuXAvKbGhLpj4P4f_dW_"
};